import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { scopeNode } from '#components/generics/js/selectors/scope.js'
import * as utilities from '#utilities/js/styles.js'
import { display } from './ui.js'
import scopeWs from './scopews.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const node = scopeNode(button, 'contracts.chat.mains.meet')
    if (node) {
      scopeWs(node)
      button.classList.add(utilities.modifiers.display.none)
      display('[data-meet="meet_accept"]')
    }
  }
})

export default span => {
  onClick.listen(span)
}
